function escapeHtml(text) {
  return String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * Open the already-rendered quote document in a new browser tab (HTML preview).
 * Much faster than generating a PDF via html2canvas.
 */
export function openQuotePreviewInNewTab(container, { title = 'Quote', windowRef } = {}) {
  if (!container) return false;

  const viewerWindow = windowRef || window.open('', '_blank');
  if (!viewerWindow) return false;

  const stylesheets = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
    .map((link) => `<link rel="stylesheet" href="${link.href}">`)
    .join('\n');

  const inlineStyles = Array.from(document.querySelectorAll('style'))
    .map((style) => style.outerHTML)
    .join('\n');

  const html = `<!DOCTYPE html>
<html lang="nl">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <title>${escapeHtml(title)}</title>
  ${stylesheets}
  ${inlineStyles}
  <style>
    html, body { margin: 0; padding: 0; background: #e2e8f0; }
    .quote-preview-window {
      box-sizing: border-box;
      padding: 24px 16px 48px;
      min-height: 100vh;
    }
    .quote-preview-window .view-quote-pdf-export-host,
    .quote-preview-window .quote-content-root {
      position: static !important;
      left: auto !important;
      top: auto !important;
      width: 794px !important;
      max-width: calc(100% - 32px) !important;
      margin: 0 auto !important;
      pointer-events: auto !important;
      overflow: visible !important;
    }
    .quote-preview-window .quote-pdf-page {
      margin-bottom: 20px;
      box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.12), 0 4px 6px -4px rgba(15, 23, 42, 0.08);
    }
    .quote-preview-window .quote-pdf-page:last-child {
      margin-bottom: 0;
    }
  </style>
</head>
<body>
  <div class="quote-preview-window">
    ${container.innerHTML}
  </div>
</body>
</html>`;

  viewerWindow.document.open();
  viewerWindow.document.write(html);
  viewerWindow.document.close();
  return true;
}
